import React from 'react';
import useMultiUiBrandContext from '../../contexts/MultiUiBrand/useMultiUiBrandContext';
import primitives from '@veneer/primitives';
import { extendSemantics } from '@veneer/semantics';
import { getThemeProviderConfig, hpxTokens } from './utils';
import { ThemeProvider as VThemeProvider } from '@veneer/theme';

const hpxTheme = extendSemantics({
  color: {
    light: {
      background: {
        container: {
          active: hpxTokens.manatee2,
          hover: hpxTokens.manatee1,
          default: primitives.color.white
        },
        default: hpxTokens.manatee3,
        disabled: hpxTokens.manatee2,
        medium: hpxTokens.manatee1
      },
      foreground: {
        default: hpxTokens.manatee12,
        disabled: hpxTokens.manatee5,
        light: hpxTokens.manatee8,
        medium: hpxTokens.manatee9
      },
      primary: {
        background: {
          active: primitives.color.royalBlue2,
          default: primitives.color.royalBlue0,
          hover: primitives.color.royalBlue1
        },
        base: {
          active: primitives.color.royalBlue9,
          default: hpxTokens.manatee11,
          hover: primitives.color.royalBlue8
        }
      }
    }
  }
});

// The designer team requested colors that are not available in the veneer theme
// So this is a workaround to apply specific themes for specific buttons in specific screen sizes
const SecondaryButtonThemeProvider = ({
  children,
  enableTheme = true
}: {
  children: React.ReactNode;
  enableTheme?: boolean;
}): React.ReactElement => {
  const { uiBrand } = useMultiUiBrandContext();
  const props = getThemeProviderConfig(uiBrand, hpxTheme);

  if (enableTheme) {
    return <VThemeProvider {...props}>{children}</VThemeProvider>;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default SecondaryButtonThemeProvider;
